import React from 'react';
import locales from '../../../../../content.json';
import { getParameterFromURL } from '../../../../../utils/scripts';
import s from './index.module.scss';
import zone from './img/zone.png';
import zoneDark from './img/zoneDark.png';

const BENEFIT_KEYS = ['payment_text_386', 'payment_text_387', 'payment_text_388', 'payment_text_389'];

export const Description = () => {
  const darkTheme = getParameterFromURL('darkTheme');

  return (
    <div className={s.wrapper}>
      <ul className={s.list}>
        <li className={s.item1} dangerouslySetInnerHTML={{ __html: locales[window.userLang].pdfUpselling_3 }} />
        <li className={s.item2} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_385 }} />
        <li>
          <ul className={s.list2}>
            {BENEFIT_KEYS.map((benefitKey) => (
              <li key={benefitKey}>{locales[window.userLang][benefitKey]}</li>
            ))}
          </ul>
        </li>
        <img className={s.listImg} src={darkTheme ? zoneDark : zone} alt="" />
      </ul>
    </div>
  );
};
